import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";
import { displayError, displaySuccess } from "../../utils/messageToast";

export const generatePayload = async (
  setLoadingButtonGeneratePayload: React.Dispatch<
    React.SetStateAction<boolean>
  >,
  clientId: string,
  authorization: string,
  ambient: string,
  alias: string,
  signOut: () => void
) => {
  try {
    setLoadingButtonGeneratePayload(true);
    const apiClient = SetupFlow(authorization);
    const response = await apiClient.post(
      `/create-payload?alias=${alias}&clientId=${clientId}&ambient=${ambient}`
    );
    navigator.clipboard.writeText(
      JSON.stringify(response.data.payload, null, 2)
    );
    displaySuccess("Payload copiado para a área de transferência!");
    setLoadingButtonGeneratePayload(false);
    return response.data.payload;
  } catch (error: any) {
    displayError("Erro ao gerar payload!");
    return;
  }
};
